import { useEffect } from 'react';

/**
 * Hook to post a iframeSize message to parent window if parent exists
 * this supports the old booking iframe in self serve and can be removed once it is deprecated
 * @param { Array<any> } runOn - dependency array to trigger the event, else once on first render.
 */
export default function useLegacyIframeResizeMessage(runOn = []) {
    useEffect(() => {
        if (window.parent) {
            window.parent.postMessage({ type: "iframeSize", data: document.body.offsetHeight }, '*')
        }
    }, runOn)
} 
